
import ReviewsViewMapSectionGoogleMap from './MapSection/GoogleMap.vue';
import ReviewsViewMapSectionDirectionCallDetailSection from './MapSection/DirectionCallDetailSection.vue';
import ReviewsViewMapSectionSocialLinks from './MapSection/SocialLinks.vue';
import ReviewsViewMapSectionSiteLinks from './MapSection/SiteLinks.vue';

export default {
  name: 'ReviewsViewMapSection',
  components: {
    ReviewsViewMapSectionGoogleMap,
    ReviewsViewMapSectionDirectionCallDetailSection,
    ReviewsViewMapSectionSocialLinks,
    ReviewsViewMapSectionSiteLinks,
  },
  props: {
    mapData: {
      type: Object,
      required: true,
    },
  },
};
